import type { QueryRollupLevelOption } from "./types";

/** Form-state sentinel for an explicit "no level" choice on primary
 * fields. Never persisted: the write path maps it to an empty level
 * stack (`levels: []`), which the backend executes at page level. A
 * sentinel (rather than an empty array) keeps the selection stable in
 * the form — the panel auto-seeds a default whenever `levels` is empty,
 * which would immediately clobber an empty-array representation. */
export const NONE_LEVEL_VALUE = "__none__";

export const NONE_LEVEL_OPTION: QueryRollupLevelOption = {
  value: NONE_LEVEL_VALUE,
  label: "None",
};

export const isNoneLevelSelection = (levels: readonly string[]): boolean =>
  levels.includes(NONE_LEVEL_VALUE);

/** Drop the sentinel before persisting a level stack. */
export const stripNoneLevel = (levels: readonly string[]): string[] =>
  levels.filter((level) => level !== NONE_LEVEL_VALUE);
